import {Component, signal} from '@angular/core';
import {sign} from 'node:crypto';
import {Button} from 'primeng/button';
import {UploadExtraImages} from '../dialogs/complete-profile-dialog/upload-extra-images/upload-extra-images';
import {SearchWidget} from './search-widget/search-widget';

@Component({
  selector: 'app-home-page',
  imports: [
    SearchWidget
  ],
  templateUrl: './home-page.html',
  styleUrl: './home-page.css',
})
export class HomePage {
  test = signal(1);

  constructor() {
    setInterval(() => this.test.update(v => v + 1), 1000)
  }

  incrementTest() {
    this.test.update(v => v + 1)
  }
}
